import { Injectable } from '@angular/core';
import { first as firstFromArray } from 'lodash-es';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { EnvironmentConfigurationService } from '@nimbus-library/features/configuration';
import { ILogger } from '@nimbus-library/features/logger/services/logger/i-logger';
import { IGeoLocationService } from '@nimbus-global/features/geo-location/services/i-geo-location.service';
import { ILocation, ITenantLocation } from '@nimbus-global/features/shared/services/api/i-location.models';
import { CookieService } from '@nimbus-library/features/shared/services/cookies/cookies.service';
import { IAuthenticationService } from '@nimbus-library/features/authentication/services/i-authentication.service';
import { BaseHttpService } from '@nimbus-library/features/shared/services/base-http/base-http.service';
import { GlobalApiRoutes } from '@nimbus-global/features/shared/services/api/global.api-routes.const';
import { IEnvironmentService } from '@nimbus-library/features/configuration/i-environment.service';

@Injectable({
  providedIn: 'root',
})
export class GeoLocationService extends IGeoLocationService {
  private readonly savedLocationPrefix = 'portal';
  private readonly locationPrefix = 'admin';

  public constructor(
    cookieService: CookieService,
    authenticationService: IAuthenticationService,
    environmentConfigurationService: EnvironmentConfigurationService,
    logger: ILogger,
    private readonly httpService: BaseHttpService,
    private readonly environmentService: IEnvironmentService,
  ) {
    super(
      `Nimbus.Admin.${environmentConfigurationService.configurationSettings.environmentName}.Location`,
      cookieService,
      authenticationService,
      environmentConfigurationService,
      null,
      logger,
    );
  }

  public async resolveSelectedLocation(): Promise<void> {
    const location = this.transformUrl(this.getSelectedLocation());
    if (location && location !== window.location.host && this.environmentService.environment.production) {
      const currentUrl = new URL(window.location.href);
      const url = new URL(`https://${location}`);
      url.pathname = currentUrl.pathname;
      currentUrl.searchParams.forEach((val, key) => url.searchParams.append(key, val));
      this.redirect(url.toString());
    }
  }

  public loadLocationInformation(): void {}

  public setSelectedLocation(_location: string): void {
    // don't save location in case of admin
  }

  public resolveLocation(_redirectUrl?: string): void {
    this.loadLocationInformation();
  }

  public getLocationsByTenantId(tenantId: string): Observable<ITenantLocation[]> {
    return this.httpService.get(GlobalApiRoutes.Locations.getLocationsByTenantId(tenantId)).pipe(map((result) => result));
  }

  protected getUrl(location: ILocation): URL {
    return new URL(`https://${this.transformUrl(location.location)}/authentication/login`);
  }

  private transformUrl(location: string): string {
    if (!location) {
      return null;
    }

    const locationFragments = location.split('.');

    if (firstFromArray(locationFragments) === this.savedLocationPrefix) {
      locationFragments.splice(0, 1, this.locationPrefix);
    }

    return locationFragments.join('.');
  }
}
